import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { withRouter, useHistory, useLocation, Redirect } from 'react-router-dom';
import {
    makeStyles,
    withStyles,
    Typography,
    Slide as MUISlide,
    Dialog,
    IconButton,
    DialogContent,
    DialogActions,
    Button,
    Backdrop,
    AppBar,
    Toolbar,
    Radio,
    FormControlLabel,
    FormControl,
    Select,
    InputLabel,
    MenuItem,
    Paper,
    fade,
    InputBase,
    List,
    ListItem,
    Divider,
    ListItemText,
    ListItemAvatar,
    ListSubheader,
    RadioGroup,
    ListItemIcon,
    Grid,
    OutlinedInput,
    InputAdornment,
    Switch,
    ListItemSecondaryAction,
    Chip,
    Popover,
    Box,
    DialogTitle,
    DialogContentText,
    Card,
    CardContent,
    FormHelperText,
    Collapse,
    Menu,
    MenuList,
    ClickAwayListener,
    Grow,
    Popper,
} from "@material-ui/core";
import Account from './Account';

const Profile = ({ }) => {

    return (
        <>
            <Redirect to="/profile/account" />
        </>
    );
}



const mapStateToProps = (state) => ({ user: state.user, vehicle: state.vehicle });
const mapDispatchToProps = (dispatch) => ({

});

const ProfileWithRouter = withRouter(Profile);
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProfileWithRouter);